import { createContext } from 'react';

export interface AuthContextType {
    loggedIn: boolean;
    role: string;
    academyId: string;
}

export const AuthContext = createContext<AuthContextType | any>(undefined);
